module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/icon_title_hibiscus-5268a1888e77d290e8779c40559d6719.svg";